import { Archive, ArchiveRestore } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { Button, Tooltip } from '@highlight/ui'
import { FLOATING_FILL_CLASS } from '@renderer/components/floating-surface'

interface ActionArchiveCircleProps {
  /** Tooltip and accessible name, e.g. "Archive", "Restore", "Dismiss". */
  label: string
  /** Draws the restore glyph instead of the archive one. */
  isArchived?: boolean
  onSelect: () => void
  /** Merged over the floating fill, for rows that size their controls together. */
  className?: string
}

/** The floating bar's archive control. */
export function ActionArchiveCircle({ label, isArchived = false, onSelect, className }: ActionArchiveCircleProps) {
  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <Button
            variant="outline"
            shape="square"
            aria-label={label}
            onClick={onSelect}
            className={twMerge(FLOATING_FILL_CLASS, className)}
          >
            {isArchived ? <ArchiveRestore aria-hidden="true" /> : <Archive aria-hidden="true" />}
          </Button>
        }
      />
      <Tooltip.Content>{label}</Tooltip.Content>
    </Tooltip>
  )
}
